<template>
	<div id="reg" class="col-12">
		<div class="panel_header">
			<div class="row align-items-end mb-4">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p class="mb-0">
						{{ block.subtitle }}
					</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<FormulateForm
				v-if="mounted && autocompleted"
				v-model="formValues"
				:schema="schema"
				class="row"
				@submit="submit"
				@setCompanyInfo="setCompanyInfo"
				@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
				@validatePhone="validatePhone"
			>
				<div v-if="allProductsFromGroup" class="col-12 order-0">
					<div class="row">
						<div class="col-12 col-lg-6">
							<products-component
								v-model="products"
								:block="block"
								@handlerChange="handlerChange"
							/>
							<div v-if="invalidProductsCount" class="error-message mb-4">
								Выберите хотя бы 1 значение
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="(isAuthorized && block.authentication_required)
						|| !block.authentication_required"
					class="col-12 order-10"
				>
					<div class="row">
						<div class="col-12 col-lg-6 mt-4">
							<div
								class="formulate-promocode"
								:class="isActivatePromocode ? 'formulate-promocode--active' : ''"
							>
								<FormulateInput
									v-show="!isActivatePromocode"
									id="promocode"
									v-model.trim="promocode"
									type="text"
									name="promo"
									placeholder="Промокод"
									class="px-0 mb-0 mr-2 promocode-input col"
								/>
								<div v-show="isActivatePromocode" class="formulate-promocode--active__text">
									Промокод применен
								</div>
								<div
									v-if="promocode.length > 0 && !isActivatePromocode"
									@click.prevent="checkPromocodeLanding"
								>
									<icon-arrow-right
										class="arrow-right--black"
									/>
								</div>
								<div
									v-else-if="isActivatePromocode"
									class="close"
									@click.prevent="resetPromocode"
								/>
							</div>
							<div
								class="mb-3 formulate-promocode__error"
							>
								{{ promocodeMessage }}
							</div>
						</div>
						<div class="col-12">
							<div v-html="block.footer_text" />
						</div>
						<div class="col-12 col-lg-6">
							<div v-if="block.show_amount" class="amount_block my-4">
								<p class="mb-0 d-flex justify-content-between">
									<span class="title mb-1">Итого</span>
									<span class="title mb-1">
										{{ createMaskAmount(productsSumWithDiscount) }} руб.
									</span>
								</p>
								<p
									v-if="productsSum > 0 && productsSum !== productsSumWithDiscount"
									class="mb-0 d-flex justify-content-end"
								>
									<span class="original_amount">
										{{ createMaskAmount(productsSum) }} руб.
									</span>
								</p>
							</div>
						</div>
						<div class="col-12">
							<FormulateInput
								class="mb-3 agreement-checkbox"
								name="publicOfferAgreement"
								type="checkbox"
								validation="required"
								:validation-messages="{
									required: `${$t('agreementRequired')}`
								}"
								data-action="publicOfferAgreement"
							>
								<template #label="{ id }">
									<label :for="id" class="ml-2">
										Отправляя форму, я принимаю
										<a
											href="/pdf/ТФ_публичной_оферты_о_принятии_участия_в_мероприятии_Среди_своих.pdf"
											target="_blank"
										>
											условия договора публичной оферты
										</a>
									</label>
								</template>
							</FormulateInput>

							<agreement-input class="mb-2" />
							<advertising-mailings-input />
							<loyalty-registration-input />

							<FormulateInput
								type="submit"
								class="mt-3"
								:disabled="isLoadingSubmit"
							>
								<b-spinner
									v-if="isLoadingSubmit"
									style="margin-right: 15px; width: 1.3em; height: 1.3em;"
								/>
								{{ isLoadingSubmit ? 'Идет отправка формы...' : 'Отправить' }}
							</FormulateInput>
							<CookieError v-if="isErrorCookie" />
						</div>
					</div>
				</div>

				<div v-else>
					<div class="col-12 mb-3">
						Необходимо быть зарегистрированным в системе
					</div>
					<FormulateInput
						type="button"
						class="mb-0 col-12"
						:disabled="isLoadingSubmit"
						@click="showLoginPopup"
					>
						Авторизоваться
					</FormulateInput>
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';

import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import IconArrowRight from '~/static/svg/icon-arrow-right.vue';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import moment from '@/utils/moment';

export default {
	components: {
		LoyaltyRegistrationInput,
		AgreementInput,
		ProductsComponent,
		IconArrowRight,
		AdvertisingMailingsInput,
		CookieError,
	},
	mixins: [formulateFormScenario],
	data() {
		return {
			productsSumWithDiscount: 0,
			productsSum: 0,
			productsCount: [],
			invalidProductsCount: false,
		};
	},
	methods: {
		getData() {
			const products = this.productsCount.filter((el) => el.quantity !== 'Выберите количество');
			if (products.length > 0) {
				if (!this.agreements.marketing_emails) {
					this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
				}
				if (!this.agreements.personal_data) {
					this.agreements.personal_data = !!this.formValues.personalData;
				}

				this.setAgreementFields();

				let userData = this.formValues;
				userData = {
					sklTargetAction: this.block.form_scenario_action_label,
					sklAgreeSubscribeLookup: this.formValues.advertisingMailingsAgreement ? 'да' : 'нет',
					sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
					...this.getAnalyticsData(),
					...userData,
				};

				this.invalidProductsCount = false;
				return {
					user_data: userData,
					products: products ?? null,
					entity_name: this.fetchedData.entity_name,
					entity_id: this.fetchedData.id,
					can_return_vat_selected: +this.can_return_vat_selected,
				};
			}
			this.invalidProductsCount = true;
		},
		async handlerChange(selected) {
			this.productsCount = selected;

			await this.$api.getSumProducts({
				form_scenario_id: this.block.scenario_id,
				products: selected.map((el) => ({
					id: el.id,
					quantity: el.quantity,
					price: +el.price,
				})).filter((el) => el.quantity !== 'Выберите количество'),
				promocode: this.isActivatePromocode ? this.promocode : null,
			}).then((res) => {
				this.productsSumWithDiscount = res.sum;
				this.productsSum = res.sumWithoutDiscount;
			});
		},
		async checkPromocodeLanding() {
			await this.checkPromocode(this.productsCount.filter((el) => el.quantity !== 'Выберите количество'));
			if (this.isActivatePromocode) {
				this.handlerChange(this.productsCount);
			}
		},
		resetPromocode() {
			this.promocode = '';
			this.isActivatePromocode = false;
			this.handlerChange(this.productsCount);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
	font-family: $font-family-base !important;
	font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}

.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;

	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}

		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}

.error-message {
	color: red;
	font-size: 0.8rem;
}

.arrow-right {
	&--black {
		fill: black;
		padding: 0;
		cursor: pointer;
	}
}

.close {
	cursor: pointer;
	opacity: 1;
}

.close::before {
	content: '\e915';
	font-size: 1rem;
}

.amount_block {
	height: 3rem;

	.original_amount {
		color: $border-color;
		font-weight: bold;
		text-decoration: line-through;
	}
}
</style>
